<template>
  <RegStepper v-if="showRegStepper" />
  <div v-else-if="bidsLoaded">
    <BidList v-if="!isNoBids" />
    <NoBids v-else />
  </div>
  <BidsNotAvailable v-else-if="!canSeeApps" />
</template>

<script>
import RegStepper from "@/components/regstepper/RegStepper.vue";
import NoBids from "@/components/bids/NoBids";
import BidList from "@/components/bids/BidList";
import BidsNotAvailable from "@/components/bids/BidsNotAvailable";
import { mapState, mapGetters } from "vuex";

export default {
  name: "Cabinet",
  components: {
    NoBids,
    BidList,
    RegStepper,
    BidsNotAvailable,
  },
  computed: {
    ...mapState("bid", ["bidsLoaded", "isNoBids"]),
    ...mapGetters("profile", ["isRegStepper", "canSeeApps", "canSeeBilling"]),
    showRegStepper() {
      return this.isRegStepper;
    },
  },
  mounted() {
    if (this.showRegStepper) return;
    if (this.canSeeApps) {
      this.$store.dispatch("bid/getBids");
    }
    if (this.canSeeBilling) {
      this.$store.dispatch("billing/getBalance");
    }
  },
};
</script>

<style lang="scss" scoped>
.cabinet {
  max-width: 960px;
  margin: 0 auto;

  &__card {
    background: #ffffff;
  }
  &__empty {
    min-height: 350px;
  }
}
</style>
